import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

/**
 * DUMB COMPONENT: ResumenRiesgosPotenciales
 *
 * Presenta el conteo de casos RP (total, abiertos, cerrados)
 * calculado por el backend y expuesto por la fachada.
 */
@Component({
  selector: 'app-resumen-riesgos-potenciales',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section
      class="mb-4 grid grid-cols-1 gap-3 sm:grid-cols-3"
      aria-label="Resumen de riesgos potenciales"
    >
      <article
        class="rounded-xl border border-sura-gray-200 bg-white p-4 shadow-sm dark:border-sura-gray-800 dark:bg-gray-900"
      >
        <p
          class="text-xs font-semibold uppercase tracking-wide text-sura-gray-800 dark:text-sura-gray-200"
        >
          Total Casos RP
        </p>
        <p
          class="mt-2 text-2xl font-bold text-sura-blue-500 dark:text-sura-blue-200"
          data-testid="rp-total"
          aria-live="polite"
        >
          {{ loading() ? '...' : total() }}
        </p>
      </article>

      <article
        class="rounded-xl border border-sura-aqua-200 bg-sura-aqua-100 p-4 shadow-sm dark:border-sura-aqua-700 dark:bg-sura-aqua-700/20"
      >
        <p
          class="text-xs font-semibold uppercase tracking-wide text-sura-gray-800 dark:text-sura-aqua-200"
        >
          Casos Abiertos
        </p>
        <p
          class="mt-2 text-2xl font-bold text-sura-blue-800 dark:text-sura-blue-100"
          data-testid="rp-abiertos"
          aria-live="polite"
        >
          {{ loading() ? '...' : abiertos() }}
        </p>
      </article>

      <article
        class="rounded-xl border border-sura-blue-200 bg-sura-blue-50 p-4 shadow-sm dark:border-sura-blue-500 dark:bg-sura-blue-800/20"
      >
        <p
          class="text-xs font-semibold uppercase tracking-wide text-sura-gray-800 dark:text-sura-blue-200"
        >
          Casos Cerrados
        </p>
        <p
          class="mt-2 text-2xl font-bold text-sura-blue-800 dark:text-sura-blue-100"
          data-testid="rp-cerrados"
          aria-live="polite"
        >
          {{ loading() ? '...' : cerrados() }}
        </p>
      </article>
    </section>
  `
})
export class ResumenRiesgosPotencialesComponent {
  loading = input(false);
  total = input(0);
  abiertos = input(0);
  cerrados = input(0);
}
